export const HOMEPAGE: string = "/" 
export const PRODUCTS: string = "/Productos" 
export const ABOUT: string = "/Nosotros" 
export const CONTACT: string = "/Contacto" 
export const PROFILE: string = "/Perfil" 
export const DETAIL: string = "/Detalle/:id" 
export const SHOP : string = "/Shop"